import { useEffect, useState } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Fetch the membership tiers configured by the admin.
 * Returns an array sorted by `order`, each item shaped like:
 *   { key, name, price_monthly, price_yearly, min_months, description,
 *     features:[], is_invite_only, ...access flags }
 *
 * The backend exposes them as a keyed dict; we normalize into an array so pages can
 * `.map` freely without caring about the wire format.
 */
export default function useMembershipTiers() {
    const [tiers, setTiers] = useState([]);
    const [loading, setLoading] = useState(true);

    const load = async () => {
        try {
            const { data } = await axios.get(`${API_URL}/api/membership/tiers`);
            const list = Array.isArray(data)
                ? data
                : Object.entries(data || {}).map(([key, val]) => ({ key, ...val }));
            list.sort((a, b) => (a.order ?? 100) - (b.order ?? 100));
            setTiers(list);
        } catch (err) {
            setTiers([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        load();
        const onChange = () => load();
        window.addEventListener('tiers-changed', onChange);
        return () => window.removeEventListener('tiers-changed', onChange);
    }, []);

    return { tiers, loading, reload: load };
}
